import { ElevarCustomerData } from './AnalyticsData';
import { extractNumericId } from '../../../utils/storefront/utils';

interface UserProperties {
  [key: string]: string | undefined;
  visitor_type: string;
}

export const mapElevarCustomerData = (customer: any): ElevarCustomerData => {
  const userProperties: UserProperties = {
    visitor_type: customer ? 'logged_in' : 'guest',
  };

  if (customer?.defaultAddress?.address1) {
    userProperties.customer_address_1 = customer.defaultAddress.address1;
  }
  if (customer?.defaultAddress?.address2) {
    userProperties.customer_address_2 = customer.defaultAddress.address2;
  }
  if (customer?.defaultAddress?.city) {
    userProperties.customer_city = customer.defaultAddress.city;
  }
  if (customer?.defaultAddress?.country) {
    userProperties.customer_country = customer.defaultAddress.country;
  }
  if (customer?.email) {
    userProperties.customer_email = customer.email;
  }
  if (customer?.firstName) {
    userProperties.customer_first_name = customer.firstName;
  }
  if (customer?.id) {
    userProperties.customer_id = extractNumericId(customer.id);
  }
  if (customer?.lastName) {
    userProperties.customer_last_name = customer.lastName;
  }
  if (customer?.numberOfOrders) {
    userProperties.customer_order_count = customer.numberOfOrders.toString();
  }
  if (customer?.phone) {
    userProperties.customer_phone = customer.phone;
  }
  if (customer?.defaultAddress?.province) {
    userProperties.customer_province = customer.defaultAddress.province;
  }
  if (customer?.defaultAddress?.provinceCode) {
    userProperties.customer_province_code = customer.defaultAddress.provinceCode;
  }
  if (customer?.tags) {
    userProperties.customer_tags = JSON.stringify(customer.tags);
  }
  if (customer?.defaultAddress?.zip) {
    userProperties.customer_zip = customer.defaultAddress.zip;
  }

  return userProperties;
};
